export enum RecordingState {
    NONE = 'NONE',
    RECORDING = 'RECORDING',
    RECORDING_PREPARE = 'RECORDING_PREPARE',
    ENCODING = 'ENCODING',
    READY = 'READY',
  }
  